import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import ThemeReducer from './ThemeReducer';
import WebsocketReducer from './WebsocketReducer';
import NotifierReducer from './NotifierReducer';
import UiReducer from './UiReducer';
import UserReducer from './UserReducer';
import AppInfoReducer from './AppInfoReducer';
import EventsReducer from './EventsReducer';
import UnitsReducer from './UnitsReducer';
import ConfigReducer from './ConfigReducer';
import EventUnitsReducer from './EventUnitsReducer';
import UnitStatusReducer from './UnitStatusReducer';
import MapReducer from './MapReducer';
import ZonesReducer from './ZonesReducer';
import ReportsReducer from './ReportsReducer';
import EsnReducer from './EsnReducer';
import PagingReducer from './PagingReducer';
import DialogsReducer from './DialogsReducer';
import E911Reducer from './E911Reducer';
import { reducer as notifications } from 'react-notification-system-redux';
import UnitResources from './UnitResourcesReducer';
import EventSortingReducer from './EventSortingReducer';
import UnitSortingReducer from './UnitSortingReducer';
import BulletinReducer from './BulletinReducer';
import DataUpdateReducer from './DataUpdateReducer';
import DictionaryReducer from './DictionaryReducer';
import UnitsNeedAttentionReducer from './UnitsNeedAttentionReducer';
import PermissionsReducer from './PermissionsReducer';
import TimeReducer from './TimeReducer';
import KeyboardReducer from './KeyboardReducer';
import UnitGroupsReducer from './UnitGroupsReducer';
import UserSettingsReducer from './UserSettingsReducer';
import ServerConnectionReducer from './ServerConnectionReducer';
import EventLocationReducer from './EventLocationReducer';
import SelectionReducer from './SelectionReducer';
import FilteredEvents from './FilteredEventsReducer';
const createRootReducer = (history) =>
  combineReducers({
    reports: ReportsReducer,
    appInfo: AppInfoReducer,
    config: ConfigReducer,
    dialogs: DialogsReducer,
    dataUpdate: DataUpdateReducer,
    dictionary: DictionaryReducer,
    e911: E911Reducer,
    esns: EsnReducer,
    events: EventsReducer,
    filteredEvents: FilteredEvents,
    eventUnits: EventUnitsReducer,
    selection: SelectionReducer,
    eventSort: EventSortingReducer,
    eventLocation: EventLocationReducer,
    keyboard: KeyboardReducer,
    map: MapReducer,
    notifications,
    notifier: NotifierReducer,
    paging: PagingReducer,
    permissions: PermissionsReducer,
    router: connectRouter(history),
    serverConnection: ServerConnectionReducer,
    theme: ThemeReducer,
    time: TimeReducer,
    ui: UiReducer,
    unitGroups: UnitGroupsReducer,
    units: UnitsReducer,
    unitSort: UnitSortingReducer,
    unitStatus: UnitStatusReducer,
    unitResources: UnitResources,
    unitsNeedAttention: UnitsNeedAttentionReducer,
    unreadBulletins: BulletinReducer,
    user: UserReducer,
    userSettings: UserSettingsReducer,
    websocket: WebsocketReducer,
    zones: ZonesReducer,
  });

export default createRootReducer;
